import $ from 'jquery';

$('.archiveAs').on('focus', function () {
    if ($(this).val() === '') {
        const archiveAsText = `${$('.firma').val()} ${$('.afdeling').val()} ${$('.fornavn').val()} ${$('.mellemnavn').val()} ${$('.efternavn').val()}`;
        $(this).val($.trim(archiveAsText.replace(/undefined/g, '').replace(/\s{2,}/g, ' ')));
    }
});
